/**
 * The host of an absolute URL as a short display label, without a leading `www.`.
 * Null when `url` does not parse as an absolute URL.
 *
 * @example hostnameLabel('https://www.fidelity.com/')   // "fidelity.com"
 * @example hostnameLabel('https://login.chase.com/app') // "login.chase.com"
 * @example hostnameLabel('www.fidelity.com')            // null
 */
export default function hostnameLabel(url: string): string | null {
  try {
    return new URL(url).hostname.replace(/^www\./, '') || null;
  } catch {
    return null;
  }
}
